import {json} from '../core/data-source/json.mapper';

export class DictionaryRecord {
    @json({
        nullable: true
    })
    id: number;
    @json()
    name: string;
}
